export default __webpack_public_path__ + "static/media/020-finger.ac0b74a4.svg";